import ActionType from '../actions/ActionType'

export const editorChange = htmlString => dispatch =>
  dispatch({ type: ActionType.Editor.CHANGE, payload: htmlString })